// src/design-system/components/SecondaryButton.jsx
import React from 'react';

/**
 * SecondaryButton — Fundo translúcido, borda leve branca, hover glow sutil.
 */
export default function SecondaryButton({
  children,
  className = '',
  size = 'md',
  fullWidth = false,
  as: Tag = 'button',
  ...props
}) {
  const cls = [
    'ds-btn-secondary',
    size === 'lg' && 'ds-btn-secondary--lg',
    size === 'sm' && 'ds-btn-secondary--sm',
    fullWidth && 'ds-btn-secondary--full',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={cls} {...props}>
      {children}
    </Tag>
  );
}
